/**
 * Shared UI component for UI Empty State.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-empty-state',
  standalone: true,
  imports: [CommonModule, CardModule, UiLabelTranslatePipe],
  templateUrl: './ui-empty-state.component.html',
  styleUrl: './ui-empty-state.component.scss'
})
export class UiEmptyStateComponent {
  readonly title = input<string>('No data available');
  readonly description = input<string>('');
}
